import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const PdfDocuments = () => {
  return (
    <Box>
      <Typography
        variant="h4"
        color="#071783"
        sx={{ fontWeight: 400 }}
        paddingTop={"3%"}
      >
        Documents
      </Typography>
    </Box>
  );
};

export default PdfDocuments;
